import { config } from 'config';
import i18n from 'i18nextInstance';
const {
    admission,
    coverages,
    dashboardEvolutions,
    diagnosisShowReasons,
    hideEvolutionColumns,
    showPatientWaitingDuration,
    turns
} = config;

export const TABLE = [{
    key: 'fullName',
    label: i18n.t('Profesional')
}, {
    display: !!dashboardEvolutions,
    key: 'evolutions',
    label: i18n.t('Evoluciones')
}, {
    key: 'received',
    label: i18n.t('Recibidas')
}, {
    key: 'attended',
    label: i18n.t('Atendidas')
}, {
    key: 'successful',
    label: i18n.t('Finalizadas')
}, {
    key: 'unattended',
    label: i18n.t('No atendidas')
}, {
    key: 'rejected',
    label: i18n.t('Rechazadas')
}, {
    key: 'total',
    label: i18n.t('Tiempo Total')
}, {
    key: 'average',
    label: i18n.t('Promedio')
}, {
    key: 'patient_waiting_duration_avg',
    label: i18n.t('Espera promedio')
}, {
    key: 'patient_turnaround_time_avg',
    label: i18n.t('Espera promedio hasta interacción')
}].filter(({ display = true }) => !!display);

export const downloadHeaders = [{
    key: 'call_id',
    label: i18n.t('ID de llamada')
}, {
    hidden: hideEvolutionColumns,
    key: 'diagnostic_type',
    label: i18n.t('Tipo de diagnóstico')
}, {
    hidden: hideEvolutionColumns,
    key: 'diagnostic_identifier',
    label: i18n.t('Identificador')
}, {
    key: 'day',
    label: i18n.t('Fecha')
}, {
    key: 'time',
    label: i18n.t('Hora')
}, {
    key: 'status',
    label: i18n.t('Estado')
}, {
    key: 'duration',
    label: i18n.t('Duración')
}, {
    hide: !showPatientWaitingDuration,
    key: 'patient_waiting_duration',
    label: i18n.t('Espera')
}, {
    hide: !showPatientWaitingDuration,
    key: 'patient_turnaround_time',
    label: i18n.t('Espera hasta interacción')
}, {
    key: 'type',
    label: i18n.t('Tipo')
}, {
    key: 'doctor_call',
    label: i18n.t('Generada por el profesional')
}, {
    key: 'coverage_validation',
    label: i18n.t('Validación')
}, {
    key: 'doctor_identification',
    label: i18n.t('Profesional')
}, {
    key: 'doctor_last_name',
    label: i18n.t('Apellido')
}, {
    key: 'doctor_first_name',
    label: i18n.t('Nombre')
}, {
    key: 'caller_identification',
    label: i18n.t('Emisor')
}, {
    key: 'doctor_specialties',
    label: i18n.t('Especialidad')
}, {
    key: 'caller_last_name',
    label: i18n.t('Apellido')
}, {
    key: 'caller_first_name',
    label: i18n.t('Nombre')
}, {
    hidden: !turns,
    key: 'appointment_type',
    label: i18n.t('Tipo de cita')
}, {
    key: 'quality',
    label: i18n.t('Calidad')
}, {
    key: 'session',
    label: i18n.t('Atención')
}, {
    key: 'payment_method',
    label: i18n.t('Método de validación')
}, {
    hidden: !coverages,
    key: 'patient_coverage',
    label: i18n.t('Cobertura')
}, {
    key: 'patient_province',
    label: i18n.t('Provincia')
}, {
    key: 'patient_city',
    label: i18n.t('Ciudad')
}, {
    key: 'patient_district',
    label: i18n.t('Barrio')
}, {
    key: 'call_type',
    label: i18n.t('Tipo')
}, {
    key: 'specialty',
    label: i18n.t('Especialidad')
}, {
    key: 'patient_affiliate',
    label: i18n.t('Afiliado')
}, {
    key: 'patient_birth_date',
    label: i18n.t('Fecha de Nacimiento')
}, {
    key: 'patient_email',
    label: i18n.t('Email')
}, {
    key: 'computed_time',
    label: i18n.t('Minutos computados')
}, {
    key: 'participants',
    label: i18n.t('Participantes')
}, {
    hidden: hideEvolutionColumns,
    key: 'symptoms',
    label: i18n.t('Síntomas')
}, {
    hidden: hideEvolutionColumns,
    key: 'diagnoses',
    label: i18n.t('Diagnóstico')
}, {
    hidden: hideEvolutionColumns,
    key: 'diagnostic_status',
    label: i18n.t('Estado del diagnóstico')
}, {
    hidden: hideEvolutionColumns,
    key: 'note',
    label: i18n.t('Evolución')
}, {
    hidden: hideEvolutionColumns || !diagnosisShowReasons,
    key: 'consultation_reasons',
    label: i18n.t('Motivo de consulta')
}, {
    hidden: hideEvolutionColumns,
    key: 'recommendations',
    label: i18n.t('Recomendaciones')
}, {
    hidden: !admission,
    key: 'admission_patient_admitted_at',
    label: i18n.t('Admitido')
}, {
    hidden: !admission,
    key: 'admission_assigned_duration',
    label: i18n.t('Espera hasta admisión')
}, {
    hidden: !admission,
    key: 'admission_accepted_duration',
    label: i18n.t('Tiempo en admisión')
}];
